// extracted by mini-css-extract-plugin
export default {"root":"_1zBb7","message":"mQS4e","button":"_3hT1x"};